import React, { useEffect, useState } from 'react';
import Switch from "react-switch";
import InnerLoader from '../../components/general/inner-loader/InnerLoader';

function Emails({ translate, settings, loadingSettings, handleEdit }) {
    const [email_project_confirming, setemail_project_confirming] = useState()
    const [email_project_accepting, setemail_project_accepting] = useState()
    const [email_project_rejecting, setemail_project_rejecting] = useState()
    useEffect(() => {
        setemail_project_confirming(settings?.emails?.email_project_confirming)
        setemail_project_accepting(settings?.emails?.email_project_accepting)
        setemail_project_rejecting(settings?.emails?.email_project_rejecting)
    }, [settings?.emails?.email_project_confirming, settings?.emails?.email_project_accepting, settings?.emails?.email_project_rejecting])
    return (
        <div className='div_setting' id='e-mails'>
            <h3>{translate('e-mails-settings')}</h3>
            <p>{translate('select-emails')}</p>

            {!loadingSettings ? (
                <>
                    <div className='all_div_setting_switch'>

                        <div className='div_setting_switch'>
                            <div>
                                <h3>{translate('projects-requests')}</h3>
                                <p>{translate("projects-requests-notification")}</p>
                            </div>
                            <div className='div_switch'>
                                <SwitchComponent checked={email_project_confirming} onChange={(value) => {
                                    console.log('value', value)
                                    setemail_project_confirming(value)
                                    handleEdit("email_project_confirming", value)
                                }} />
                            </div>
                        </div>
                    </div>

                    <div className='all_div_setting_switch'>

                        <div className='div_setting_switch'>
                            <div>
                                <h3>{translate('accepting-projects')}</h3>
                                <p>{translate('accepting-projects-notification')}</p>
                            </div>
                            <div className='div_switch'>
                                <SwitchComponent checked={email_project_accepting} onChange={(value) =>{ 
                                    setemail_project_accepting(value)
                                    handleEdit("email_project_accepting", value)}} />
                            </div>
                        </div>
                    </div>

                    <div className='all_div_setting_switch'>

                        <div className='div_setting_switch'>
                            <div>
                                <h3>{translate('reject-projects')}</h3>
                                <p>{translate('reject-projects-notification')}</p>
                            </div>
                            <div className='div_switch'>
                                <SwitchComponent checked={email_project_rejecting} onChange={(value) =>{ 
                                    setemail_project_rejecting(value)
                                    handleEdit("email_project_rejecting", value)}} />
                            </div>
                        </div>
                    </div>

                </>
            ) : (
                <InnerLoader />
            )}
        </div>
    );
}

function SwitchComponent({ checked, onChange }) {
    return (
        <Switch
            onColor='#756bc1'
            checkedIcon={false}
            uncheckedIcon={false}
            height={20}
            width={40}
            handleDiameter={15}
            checked={checked}
            onChange={onChange}
        />
    );
}
export default Emails;
